module.exports = __webpack_public_path__ + "a11bdae5a4b3e9178343d87730778238.png";